import { useState } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import SimpleSearch from '../../../../../components/core/SimpleSearch';
import {
  ADMIN_ORGANIZATIONS_PATHS,
  ADMIN_PATH,
  ADMIN_SCHOOLS_PATHS,
  ADMIN_TAB_PATHS
} from '../../../../../constants/paths.constants';
import { ADMIN_SCHOOLNETS_RESOURCE } from '../../../../../resources/admin/admin.schoolnets.resource';
import adminSchoolsService from '../../../../../services/api/admin.schools.service';
import ResourceTable from '../../../../core/ResourceTable';
import AdminSchoolsSearchResults from './AdminSchoolsSearchResults';

const resource = ADMIN_SCHOOLNETS_RESOURCE;
const MODES = {
  NETS: 0,
  SEARCH_RESULTS: 1
};

const AdminSchools = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState(MODES.NETS);
  const [query, setQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const handleClear = () => {
    setMode(MODES.NETS);
    setQuery('');
    setSearchResults([]);
  };

  const handleSearch = () => {
    setMode(MODES.SEARCH_RESULTS);
    setIsSearching(true);
    adminSchoolsService.search(query, {
      onError: () => {},
      onSuccess: (results) => {
        setSearchResults(results);
        setIsSearching(false);
      }
    });
  };

  const handleResultSelect = (selected) => {
    const parentIds = selected?.spoEntityData?.agodi?.treePath?.split('#')?.filter((id) => !!id);
    if (parentIds?.length === 0) {
      navigate(
        generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`,
          { netId: selected.id }
        )
      );
    }
    if (parentIds?.length === 1) {
      navigate(
        generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`,
          { netId: parentIds[0], managementId: selected.id }
        )
      );
    }
    if (parentIds?.length === 2) {
      navigate(
        generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.SCHOOLS.path}`,
          { netId: parentIds[0], managementId: parentIds[1], communityId: selected.id }
        )
      );
    }
    if (parentIds?.length === 3) {
      navigate(
        generatePath(
          `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.BRANCHES.path}`,
          { netId: parentIds[0], managementId: parentIds[1], communityId: parentIds[2], schoolId: selected.id }
        )
      );
    }
  };

  return (
    <div className="spo-o-admin-schools">
      <SimpleSearch
        className="u-margin-bottom"
        query={query}
        canSearch={query?.length > 2}
        onClear={handleClear}
        onSearch={handleSearch}
        onChange={setQuery}
        description="Voer minimaal 3 tekens in om te zoeken"
      />
      {mode === MODES.NETS && <ResourceTable resource={resource} />}
      {mode === MODES.SEARCH_RESULTS && (
        <AdminSchoolsSearchResults
          results={searchResults}
          isLoading={isSearching}
          onResultSelect={handleResultSelect}
        />
      )}
    </div>
  );
};

export default AdminSchools;
